import { render, staticRenderFns } from "./simplifyCarFee.vue?vue&type=template&id=d001b5c2&scoped=true"
import script from "./simplifyCarFee.vue?vue&type=script&lang=js"
export * from "./simplifyCarFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyCarFee.vue?vue&type=style&index=0&id=d001b5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d001b5c2",
  null
  
)

export default component.exports